module.exports = __webpack_public_path__ + "static/media/illustration.14cb6d35.svg";